import React from "react";
import RightServiceCard1Section1 from "./RightServiceCard1Section1";
import new1 from "../../../../images/serviceimage/new1.jpeg";
import new4 from "../../../../images/serviceimage/new4.jpg"
import new3 from "../../../../images/serviceimage/new3.jpeg";
const RightServiceCardSection1 = (props) => {
  if (props.row === "top") {
    return (
      <div className="max-w-7xl lg:flex">
        <RightServiceCard1Section1
          image={new1}
          date="26-01-23"
          line="|"
          // name="kanak"
          heading="Republic Day"
          // para="jdfng dhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
        />
        <RightServiceCard1Section1
          image={new4}
          date="20-05-22"
          line="|"
          // name="k"
          heading="Summer Camp"
          // para="jdfng dhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
        />
      </div>
    );
  }
  if (props.row === "middle") {
    return (
      <div className="max-w-7xl lg:flex">
        <RightServiceCard1Section1
          image={new3}
          // date="0000000000000"
          // line="|"
          // name="deepak"
          // heading="loem h tu"
          // para="jdfng dhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
        />
        <RightServiceCard1Section1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcJs3lkqHXYLXcKXmcl0q3JDwRNtXpIgQSRBcvFnQQtsn110_82omch6Z6nkIm7pWOzIQ&usqp=CAU"
          date="678"
          line="|"
          // name="gems"
          heading="loem "
          // para="jdfng dhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
        />
      </div>
    );
  } else {
    return (
      <div className="max-w-7xl lg:flex">
        <RightServiceCard1Section1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcJs3lkqHXYLXcKXmcl0q3JDwRNtXpIgQSRBcvFnQQtsn110_82omch6Z6nkIm7pWOzIQ&usqp=CAU"
          date="0000000000000"
          line="|"
          name="pooja"
          heading="loem h tu"
          para="jdfng dhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
        />
        <RightServiceCard1Section1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcJs3lkqHXYLXcKXmcl0q3JDwRNtXpIgQSRBcvFnQQtsn110_82omch6Z6nkIm7pWOzIQ&usqp=CAU"
          date="678"
          line="|"
          name="rishuak"
          heading="loem h tu"
          para="jdfng dhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
        />
      </div>
    );
  }
};
export default RightServiceCardSection1;
